"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Utilities$ = exports.Utilities$outboundSchema = exports.Utilities$inboundSchema = void 0;
exports.utilitiesToJSON = utilitiesToJSON;
exports.utilitiesFromJSON = utilitiesFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const boolmeta_js_1 = require("./boolmeta.js");
const solarpower_js_1 = require("./solarpower.js");
const stringmeta_js_1 = require("./stringmeta.js");
const windturbines_js_1 = require("./windturbines.js");
/** @internal */
exports.Utilities$inboundSchema = z.object({
    mains_fuel_type: z.nullable(stringmeta_js_1.StringMeta$inboundSchema),
    mains_gas: z.nullable(boolmeta_js_1.BoolMeta$inboundSchema),
    solar_power: z.nullable(solarpower_js_1.SolarPower$inboundSchema),
    water_company: z.nullable(stringmeta_js_1.StringMeta$inboundSchema).optional(),
    wind_turbines: z.nullable(windturbines_js_1.WindTurbines$inboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "mains_fuel_type": "mainsFuelType",
        "mains_gas": "mainsGas",
        "solar_power": "solarPower",
        "water_company": "waterCompany",
        "wind_turbines": "windTurbines",
    });
});
/** @internal */
exports.Utilities$outboundSchema = z.object({
    mainsFuelType: z.nullable(stringmeta_js_1.StringMeta$outboundSchema),
    mainsGas: z.nullable(boolmeta_js_1.BoolMeta$outboundSchema),
    solarPower: z.nullable(solarpower_js_1.SolarPower$outboundSchema),
    waterCompany: z.nullable(stringmeta_js_1.StringMeta$outboundSchema).optional(),
    windTurbines: z.nullable(windturbines_js_1.WindTurbines$outboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        mainsFuelType: "mains_fuel_type",
        mainsGas: "mains_gas",
        solarPower: "solar_power",
        waterCompany: "water_company",
        windTurbines: "wind_turbines",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var Utilities$;
(function (Utilities$) {
    /** @deprecated use `Utilities$inboundSchema` instead. */
    Utilities$.inboundSchema = exports.Utilities$inboundSchema;
    /** @deprecated use `Utilities$outboundSchema` instead. */
    Utilities$.outboundSchema = exports.Utilities$outboundSchema;
})(Utilities$ || (exports.Utilities$ = Utilities$ = {}));
function utilitiesToJSON(utilities) {
    return JSON.stringify(exports.Utilities$outboundSchema.parse(utilities));
}
function utilitiesFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.Utilities$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'Utilities' from JSON`);
}
//# sourceMappingURL=utilities.js.map